import {LinkCard} from "@/components/cards";
import {IMAGE_URL, LOCAL_IMAGE_URL} from "@/constants/general-constants";
import {useSelector} from "react-redux";

export default function MainLinks() {

    const layoutData = useSelector((state) => state.layout.data);
    const {quick_links = []} = layoutData;

    return (
        <div className='lg:grid lg:grid-cols-[28%_28%_44%] flex flex-col justify-between gap-4 lg:gap-5'>
            {
                quick_links?.map((item, index) => (
                    <LinkCard
                        key={index}
                        href={item.link}
                        parentClasses="min-h-[6.75rem]"
                        style={{backgroundImage: `url('${item.background ? IMAGE_URL + item.background : LOCAL_IMAGE_URL + "laptop-bg-3.webp"}')`}}
                        overLayProps={{style: {background: "linear-gradient(135deg, rgba(252,250,255,0.95) 25%, rgba(252,250,255,0.69) 100%)"}}}
                    >
                        <p className="text-left text-pol-dark font-bold text-lg lg:text-base">
                            <span>{item.title}</span>
                            <i className="icon-simple-arrow-left mr-2.5 text-pol-orange-dark text-sm lg:text-xs"/>
                        </p>
                    </LinkCard>
                ))
            }
        </div>
    )
}
